var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDeleteRed = function SvgDeleteRed(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75522 3.68229C4.75522 1.00805 4.76058 1 7.43751 1",
    stroke: "#f1585e",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1199 3.41406C10.1199 1.00697 10.1145 1 7.43758 1",
    stroke: "#f1585e",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2658 3.14592C12.2657 3.14592 12.2657 3.14592 12.2656 3.14592H2.60946H1.00008C0.703804 3.14592 0.463623 3.3861 0.463623 3.68238C0.463623 3.97866 0.703804 4.21884 1.00008 4.21884H2.073V10.6563V10.6649V10.6649V10.6796V11.1928C2.073 11.203 2.07328 11.2131 2.07384 11.2231C2.07639 11.7581 2.08667 12.2082 2.12803 12.5748C2.18286 13.0606 2.30204 13.5161 2.63631 13.85C2.97051 14.1838 3.42612 14.3025 3.9116 14.357C4.39695 14.4115 5.02887 14.4115 5.8098 14.4115H5.82821H9.04696H9.05556H9.05557H9.05558H9.05559H9.0556H9.05561C9.8421 14.4115 10.4778 14.4115 10.9655 14.3564C11.4513 14.3016 11.9068 14.1824 12.2407 13.8482C12.5745 13.5139 12.6932 13.0583 12.7477 12.5729C12.7884 12.2103 12.7987 11.766 12.8013 11.2389C12.8026 11.2237 12.8032 11.2083 12.8032 11.1927L12.8022 4.21884H13.8751C14.1714 4.21884 14.4115 3.97866 14.4115 3.68238C14.4115 3.3861 14.1714 3.14592 13.8751 3.14592H12.2658ZM11.7293 4.21884H3.14591V10.6563C3.14591 11.4722 3.14732 12.0392 3.19418 12.4544C3.24145 12.8734 3.32525 13.0217 3.39453 13.0909C3.46388 13.1602 3.61239 13.2438 4.03128 13.2908C4.44649 13.3374 5.01307 13.3385 5.82821 13.3385H9.04696C9.86289 13.3385 10.4299 13.3371 10.8452 13.2903C11.2641 13.243 11.4124 13.1592 11.4816 13.0899C11.5509 13.0206 11.6345 12.8721 11.6815 12.4532C11.7281 12.038 11.7292 11.4714 11.7292 10.6563C11.7292 10.6452 11.7296 10.6342 11.7302 10.6234L11.7293 4.21884Z",
    fill: "#f1585e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29181 6.36462V11.1927",
    stroke: "#f1585e",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43758 6.36462V11.1927",
    stroke: "#f1585e",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58334 6.36462V11.1927",
    stroke: "#f1585e",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-red.152c1f03.svg";
export { ForwardRef as ReactComponent };